module.exports = __webpack_public_path__ + "img/gb938.prt.0be3d5b6.jpg";